import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';
import SimplePasswordChangeModal from './SimplePasswordChangeModal';
import logger from '../../utils/logging/logger';
import { AuthPage, AuthCard } from './AuthLayout';

const Container = styled.div`
  width: 100%;
`;

const Title = styled.h2`
  color: var(--primary-color);
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-align: center;
`;

const Subtitle = styled.p`
  color: var(--text-secondary);
  font-size: 0.875rem;
  text-align: center;
  margin-bottom: 2rem;
`;

const InfoBox = styled.div`
  background: var(--background-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--card-radius);
  padding: 1rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const InfoText = styled.p`
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin: 0;
  line-height: 1.5;
`;

function PasswordChangeRequired() {
  const [showPasswordChangeModal, setShowPasswordChangeModal] = useState(true);
  const { markPasswordChanged, logout } = useAuth();

  const handlePasswordChangeSuccess = () => {
    logger.debug('Password changed successfully');
    setShowPasswordChangeModal(false);
    markPasswordChanged();
    // The App.js will automatically redirect to dashboard since password_change_required will be false
  };

  const handleCloseModal = async () => {
    logger.debug('Closing password change modal and logging out');
    setShowPasswordChangeModal(false);
    await logout();
    // User will be redirected to login page automatically
  };

  return (
    <AuthPage>
      <AuthCard>
        <Container>
          <Title>Password Change Required</Title>
          <Subtitle>For security reasons, you must change your password before continuing.</Subtitle>
          
          <InfoBox>
            <InfoText>
              This is your first time logging in or your password needs to be updated. 
              Please choose a strong password to continue.
            </InfoText>
          </InfoBox>

          <SimplePasswordChangeModal
            isOpen={showPasswordChangeModal}
            onClose={handleCloseModal} // Allow closing - will log user out and return to login
            onSuccess={handlePasswordChangeSuccess}
          />
        </Container>
      </AuthCard>
    </AuthPage>
  );
}

export default PasswordChangeRequired;
